<template lang="pug">
.reservation-edit-text-modal
  b-modal(v-model="_modalShow" size="lg" no-close-on-backdrop no-close-on-esc @ok="ok")
    template(#modal-title)
      span {{ modalTitle }}

    .register-body
      FormLabel(key-name="家族からの連絡事項" :value="_text")

    template(#modal-footer="{ ok, cancel }")
      .buttons
        button.btn.modal-ok-btn(type="button" @click="ok()") OK
        button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import FormLabel from "@/pc/components/forms/FormLabel.vue";

/**
 * ### 連絡事項更新確認モーダル
 */
@Component({
  components: {
    FormLabel
  }
})
export default class EditTextConfirmModal extends Vue {
  /** モーダル表示可否 */
  @Prop()
  value!: boolean;
  /** モーダルタイトル */
  @Prop()
  modalTitle!: string;
  /** 本文 */
  @Prop()
  text!: string;

  get _modalShow(): boolean {
    return this.value;
  }

  set _modalShow(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _text(): string {
    return this.text;
  }

  /**
   * ### OKボタン押下処理
   *
   * - モーダルを非表示にするか否かは親コンポーネントに移譲する
   */
  public async ok(modalEvent: any): Promise<void> {
    modalEvent.preventDefault();
    this.$emit("ok");
    return;
  }
}
</script>
